export * from './common';
export const DEFAULT_REFERRAL = 'Login';
export const LOGOUT_REDIRECT = 'Login';
export const SOMMD_WELCOME_INIT = 'sommd_welcome_init';
